import React from 'react';
import { RadioButtonGroup, RadioButton } from 'material-ui';
import TypeControlledTextField from '../../../tc-ui/type-controlled-textfield.jsx';

const RateType =
({
   rateType,
   commissionPercentage,
   nettCommission,
   updateRateType,
   updateCommission,
   updateNettCommission,
}) => {
  return (
    <div>
      <RadioButtonGroup
        style={{ display: 'inline-block', width: '65%' }}
        name="rateType"
        valueSelected={rateType}
        onChange={(_, value) => updateRateType(value)}
      >
        <RadioButton
          value="nett"
          label="Nett"
          labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
          style={{ display: 'inline-block', width: '50%' }}
        />
        <RadioButton
          value="includeCommission"
          data-cy="includeCommission"
          label={`Commission${rateType === 'includeCommission' ? ':' : ''}`}
          labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
          style={{ display: 'inline-block', width: '50%' }}
        />
      </RadioButtonGroup>
      {
        // rateType === 'includeCommission' ? (
        //   <div style={{ display: 'inline-block', width: '80%', minWidth: '60px', marginLeft: '5%' }}>
        //     <TypeControlledTextField
        //       style={{ display: 'inline-block', bottom: '8px', height: 'inherit', width: '30%' }}
        //       hintStyle={{ fontSize: '12px', bottom: '0' }}
        //       inputStyle={{ fontSize: '14px', textAlign: 'right', paddingRight: '4px' }}
        //       errorStyle={{ fontSize: '10px', bottom: '-12px', width: '100px' }}
        //       underlineStyle={{ bottom: '0' }}
        //       underlineFocusStyle={{ bottom: '0' }}
        //       underlineDisabledStyle={{ bottom: '0' }}
        //       controlledType="number"
        //       value={commissionPercentage}
        //       onChange={({ target: { value } }) => updateCommission(value)}
        //     />
        //     <span style={{ color: 'rgba(0, 0, 0, 0.54)', display: 'inline-block', position: 'relative', bottom: '8px' }}>
        //       %
        //     </span>
        //   </div>
        // ) : undefined
      }
      {
        rateType === 'nett' || rateType === 'includeCommission' ? (
          <div style={{ width: '80%', display: 'flex', height: '48px', alignItems: 'center' }}>
            Based on &nbsp;
            <TypeControlledTextField
              style={{ display: 'inline-block', width: '67px' }}
              hintStyle={{ fontSize: '12px' }}
              inputStyle={{ fontSize: '14px' }}
              errorStyle={{ fontSize: '10px' }}
              hintText="Percentage"
              data-cy="percentage"
              controlledType="number"
              value={rateType === 'includeCommission' ? commissionPercentage : nettCommission}
              onChange={({ target: { value } }) => {
                if (rateType === 'includeCommission') updateCommission(value);
                else updateNettCommission(value)
              }}
            />
            % commission
          </div>
        ) : undefined
      }
    </div>
  )
}

export default RateType;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/RateType.jsx